import { render, staticRenderFns } from "./BaseToken.vue?vue&type=template&id=02bc0433&scoped=true&"
import script from "./BaseToken.vue?vue&type=script&lang=ts&"
export * from "./BaseToken.vue?vue&type=script&lang=ts&"
import style0 from "./BaseToken.vue?vue&type=style&index=0&id=02bc0433&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bc0433",
  null
  
)

export default component.exports